/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { SubSink } from 'subsink';
import { Injectable, OnDestroy } from '@angular/core';
import { CoreService } from '@arc/arc-shared-frontend';
import { BehaviorSubject, forkJoin, Observable, Subject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService implements OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private loadingSources: BehaviorSubject<any>[] = [];
  private loading$ = new Subject<void>();
  private subSink = new SubSink();
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this._isLoading$.asObservable();

  constructor(private coreService: CoreService) {
    this.startLoadingActionsListener();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadUntil(source: Observable<any>) {
    const subject = new BehaviorSubject(null);

    this.subSink.add(source.subscribe(subject));

    this.loadingSources.push(subject);
    this.loading$.next();
  }

  private startLoadingActionsListener() {
    this.loading$
      .pipe(
        tap(() => {
          this.coreService.isLoading = true;
          this._isLoading$.next(true);
        }),
        switchMap(() => {
          const sources = this.loadingSources.filter((x) => !x.isStopped);
          return forkJoin(sources);
        }),
      )
      .subscribe(() => {
        this.coreService.isLoading = false;
        this._isLoading$.next(false);
        this.loadingSources = [];
      });
  }
}
